import React, { Component } from 'react';
import { connect } from 'react-redux';
import './TVMode.scss';
import SendShoutout from '../../components/SendShoutout';
import { Modal } from '../../components';
import { getUserMetrics } from '../../actions/MetricsActions';
import { updateQueue, getTVModeQueue, getFilteredShoutouts, pickWinner, addToNewShoutouts, showCodeCommitStats } from '../../actions/TVModeAction';
import { showHelp } from '../../actions/ToastActions';
import TVModeOverlay from './TVModeOverlay';

const ROTATION_INTERVAL = 10000;

class TVMode extends Component {
  state = {
    newShoutout: null, showSend: false, reelStarted: true, metrics: [], alertMode: false
  };


  interval = null;
  hoverTimeout = null;
  lastHover = null;
  overlay = null;

  constructor() {
    super();
    this.onKeyup = this.onKeyup.bind(this);
  }

  componentDidMount() {
    if (window.zE) window.zE('webWidget', 'hide');
    this.initializeTVMode();
    document.addEventListener('keyup', this.onKeyup);
    this.startReel();
    this.props.showHelp();
  }

  async initializeTVMode() {
    if (!this.props.timeFrame || !this.props.users || !this.props.users.length) {
      await this.props.showCodeCommitStats(JSON.parse(localStorage.getItem('showStats')));
      await this.props.getFilteredShoutouts(JSON.parse(localStorage.getItem('selectedUsers')), localStorage.getItem('timeFrame'));
    }
    this.props.getTVModeQueue();
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.onKeyup);
    this.stopReel();
    localStorage.removeItem('selectedUsers');
    localStorage.removeItem('timeFrame');
    localStorage.removeItem('showStats');
    if (window.zE) window.zE('webWidget', 'show');
    this.props.showHelp();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { newShoutout } = nextProps;
    if (newShoutout && newShoutout !== this.props.newShoutout) {
      this.props.addToNewShoutouts(newShoutout);
    }
  }

  onKeyup(event) {
    this.escapeTVMode(event);
    this.pickWinner(event);
    this.switchSlideOrPause(event);
  }

  escapeTVMode(e) {
    const { history } = this.props;
    if (!e || e.key === 'Escape') {
      history.push('/');
    }
  }

  pickWinner(e) {
    if ((!e || e.key === 'w') && this.props.showWinnerButton) {
      this.props.pickWinner();
    }
  }

  switchSlideOrPause(event) {
    if (this.state.newShoutout) return;
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      this.stopReel();
      if (event.key === 'ArrowRight') this.props.updateQueue('forwards');
      else this.props.updateQueue('backwards');
      this.startReel();
    }
    if (event.key === ' ' || event.key === 'p') {
      if (this.state.reelStarted) this.stopReel();
      else this.startReel();
    }
  }

  startReel() {
    this.setState({ reelStarted: true });
    if (this.interval) clearInterval(this.interval);
    this.interval = setInterval(() => this.props.updateQueue('forwards'), ROTATION_INTERVAL);
    if (this.overlay) this.overlay.getWrappedInstance().startTrackingProgress();
  }

  stopReel() {
    this.setState({ reelStarted: false });
    if (this.interval) clearInterval(this.interval);
    if (this.overlay && this.overlay.progressInterval) this.overlay.getWrappedInstance().clearProgress();
    if (this.hoverTimeout) clearTimeout(this.hoverTimeout);
  }

  renderQueue() {
    const { queue, alert } = this.props;
    if (alert && queue && alert.length && queue.length) {
      if (this.state.reelStarted) this.stopReel();
      if (!this.state.alertMode) this.setState({ alertMode: true });
      return (
        <div>
          {alert[0]}
          {queue[0]}
        </div>
      );
    }
    if (alert && alert.length) {
      if (!this.state.alertMode) this.setState({ alertMode: true });
      if (this.state.reelStarted) this.stopReel();
      return alert[0];
    }
    if (queue && queue.length) {
      if (!this.state.reelStarted && this.state.alertMode) {
        this.setState({ alertMode: false });
        this.startReel();
      }
      return queue[0];
    }
    else return null;
  }

  render() {
    const { showSend } = this.state;

    return (
      <div style={{ overflow: 'hidden', position: 'fixed', top: 0, left: 0, bottom: 0, right: 0 }}>
        <Modal showModal={showSend} closeModal={() => this.setState({ showSend: null })} width="80%">
          <SendShoutout modalMode onHeightChange={() => { }} startBig={true} onClose={() => this.setState({ showSend: false })} />
        </Modal>
        {this.renderQueue()}
        <TVModeOverlay
          ref={(ref) => this.overlay = ref}
          isDarkFooter={false}
          reelStarted={this.state.reelStarted}
          ROTATION_INTERVAL={ROTATION_INTERVAL}
          switchSlideOrPause={() => this.switchSlideOrPause()}
          escapeTVMode={() => this.escapeTVMode()}
          pickWinner={() => this.pickWinner()}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ shoutoutsStore, tvModeStore, usersStore }) => {
  const { newShoutout, shoutoutsLoading } = shoutoutsStore;
  const { showWinnerButton, timeFrame, users, queue, alert } = tvModeStore;
  const { isFocus } = usersStore;

  return { newShoutout, shoutoutsLoading, users, isFocus, showWinnerButton, timeFrame, queue, alert
  };
};

export default connect(mapStateToProps, { getUserMetrics, getFilteredShoutouts, updateQueue,
  getTVModeQueue, pickWinner, addToNewShoutouts, showCodeCommitStats, showHelp  })(TVMode);



// WEBPACK FOOTER //
// ./src/screens/tv/TVMode.js